import { PDKCDKIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Audit, CoreDeal as Deal, RapidReconStep } from '@/models/types';
import { Calendar, CircleUser } from 'lucide-react';
import DealDeliveryPreferenceBadge from '../delivery-preference/deal-delivery-preference-badge';
import { DealPriorityBadge } from '../priority/deal-priority-badge';
import { DealStatusBadge } from '../status/deal-status-badge';
import { RapidReconStepBadge } from '../vehicle/rapid-recon-step/rapid-recon-step-badge';

const AuditIcon = ({
  audit,
  className,
}: {
  audit: Audit;
  className?: string;
}) => {
  switch (audit.field) {
    case 'status':
      return (
        <DealStatusBadge
          value={audit.new_value as Deal['status']}
          hideCopy
          className={cn('pointer-events-none size-5', className)}
        />
      );
    case 'priority':
      return (
        <DealPriorityBadge
          value={audit.new_value as Deal['priority']}
          hideCopy
          className={cn('pointer-events-none size-5', className)}
        />
      );
    case 'delivery_preference':
      return (
        <DealDeliveryPreferenceBadge
          value={audit.new_value as Deal['delivery_preference']}
          hideCopy
          className={cn('pointer-events-none size-5', className)}
        />
      );
    case 'delivery_date':
      return (
        <Calendar className={cn('pointer-events-none size-5', className)} />
      );
    case 'cdk_deal_id':
      return <PDKCDKIcon className={cn('pointer-events-none', className)} />;
    case 'vehicle.rapid_recon_step':
      return (
        <RapidReconStepBadge
          value={audit.new_value as RapidReconStep}
          hideCopy
          className={cn('pointer-events-none size-5', className)}
        />
      );
    default:
      return (
        <CircleUser
          className={cn('size-5 cursor-pointer text-gray-500', className)}
        />
      );
  }
};

export default AuditIcon;
